import React from "react";
// import { MDBBtn, MDBBtnGroup, MDBBadge } from "mdbreact";
import { Grid, Card, CardContent, Paper } from "@material-ui/core";
import { getStatsRemoval, getValors } from "../../../api/dashboardApi";
import { makeStyles } from "@material-ui/core/styles";
import Cards from "./Cards";
import Charts from "./Charts";
import NumberFormat from "react-number-format";
import Dates from "./Dates";
import { DynamicTable } from '../../common/index';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));
const months = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];
export default function ModalDelete() {
  const classes = useStyles();
  // const [status, setStatus] = React.useState(null)
  const dateNow = new Date();
  const [dateInit, setDateInit] = React.useState(
    new Date(dateNow.getFullYear(), dateNow.getMonth(), 1)
  );
  const [dateFinish, setDateFinish] = React.useState(
    new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 0, 23, 59, 59)
  );
  const [data, setData] = React.useState(null);
  const [dolar, setDolar] = React.useState(730);
  const [uf, setUf] = React.useState(28300);

  //! Definir columnas principales
  const columns = [
    { field: "modelo", label: "Modelo este es el modelo" },
    { field: "empresa", label: "Empresa / Local" },
    { field: "imei", label: "IMEI" },
  ];

  //! Datos con subtablas dinámicas
  const rows = [
    {
      modelo: "CIRC10 - pasando",
      empresa: "Acción Circular / Sucursal 1",
      imei: "865456052731708",
      configSubColumns: {
        columns: [
          { field: "sensor", label: "Sensor de llenado" },
          { field: "estado", label: "Estado" },
        ],
        rows: [
          { sensor: "Sensor A", estado: "Activo" },
          { sensor: "Sensor B", estado: "Inactivo", configSubColumns: {
            columns: [
              { field: "detalle", label: "Detalle" },
              { field: "valor", label: "Valor" },
            ],
            rows: [
              { detalle: "Temperatura", valor: "22°C" },
              { detalle: "Humedad", valor: "60%" },
            ],
          }},
        ],
      },
    },
    {
      modelo: "CIRC20",
      empresa: "Acción Circular / Sucursal 2",
      imei: "865456052726237",
      configSubColumns: {
        columns: [
          { field: "sensor", label: "Sensor" },
          { field: "estado", label: "Estado" },
        ],
        rows: [
          { sensor: "Sensor X", estado: "Activo" },
          { sensor: "Sensor Y", estado: "Inactivo" },
        ],
      },
    },
  ];

  React.useEffect(() => {
    // getValors().then((response) => {
    //   setDolar(response.dolar.valor);
    //   setUf(response.uf.valor);
    // });
    // getStatsRemoval({ dateInit, dateFinish }).then((response) => {
    //   setData(response);
    // });
    console.log("EN DASHBOARD")
  }, [dateInit, dateFinish]);

  return (
    <Paper className={classes.root}>
      {/* <DynamicTable columns={columns} rows={rows} />  */}
      <Card>
        <CardContent>
          <Dates
            setDateInit={setDateInit}
            setDateFinish={setDateFinish}
            dateInit={dateInit}
            dateFinish={dateFinish}
          />
          <hr />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <h5 style={{ textAlign: "center" }}>
                UF{" "}
                <NumberFormat
                  value={Math.round(uf, 0)}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />{" "}
                CLP
              </h5>
            </Grid>
            <Grid item xs={6}>
              <h5 style={{ textAlign: "center" }}>
                Dolar{" "}
                <NumberFormat
                  value={Math.round(dolar, 0)}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />{" "}
                CLP
              </h5>
            </Grid>
          </Grid>
          <hr />
          <Cards data={data} uf={uf} />
          <hr />
          <Charts data={data} uf={uf} />
          <hr />
        </CardContent> 
        {/* <h4>Temporalmente deshabilitado</h4> */}
      </Card>
    </Paper>
  );
}
